module.exports = __webpack_public_path__ + "static/media/xmark.6ec73873.png";